module.exports = new __parcel__URL__("audio-profile.4a798420.png").toString();